import { Api } from './Api';

const  ENPOINTS = {
    CategorieUser: 'categorie-users',
};

const getAll = signal => {
    return Api.get(ENPOINTS.CategorieUser, signal)
}

const getById = (id, signal) => {
    return Api.get(`${ENPOINTS.CategorieUser}/${id}`, signal);
}

const create = (payload, signal) => {
    return Api.post(ENPOINTS.CategorieUser, payload, signal)
}

const update = (id, payload, signal) => {
    return Api.put(`${ENPOINTS.CategorieUser}/${id}`, payload, signal)
}
const destroy = (id, signal) => {
    return Api.erase(`${ENPOINTS.CategorieUser}/${id}`, signal)
}

export const CategorieUserService = {
    getAll,
    getById,
    create,
    update,
    destroy
}